import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from "rxjs";
import { NGXLogger } from "ngx-logger";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedLibraryService } from "../../../../../petszel-shared/src/lib/services/shared.config";
import { OwnerFamilyService } from "../../service/owner-family.service";
import { Store } from "@ngrx/store";
import { AppStateModel } from "../../shared-store/app-state.model";
import { selectOwner } from "../../shared-store/owner/owner.selectors";
import { setOwner } from "../../shared-store/owner/owner.actions";
import { OwnerUpdateRequest } from "../../../../../petszel-shared/src/lib/shared-models/owner.model";
import { LatestToSModel } from "../../shared-store/selected-variables/selected-variables.reducer";
import * as _ from "lodash";

@Component({
  selector: 'app-terms-and-conditions-modal',
  templateUrl: './terms-and-conditions-modal.component.html',
  styleUrls: ['./terms-and-conditions-modal.component.scss']
})
export class TermsAndConditionsModalComponent implements OnInit, OnDestroy {
  @Input() latestToS!: LatestToSModel;
  ownerInfo!: any;
  termsOfServiceURL: string = '';
  loading = false;

  private getOwnerSubs!: Subscription;
  private manageOwnerSubs!: Subscription;
  private termsOfServiceSubs!: Subscription;

  constructor(private logger: NGXLogger,
              private activeModalService: NgbActiveModal,
              private ownerFamilyService: OwnerFamilyService,
              private sharedLibraryService: SharedLibraryService,
              private store: Store<AppStateModel>) {
  }

  ngOnInit(): void {
    this.getOwnerSubs = this.store.select(selectOwner)
      .subscribe(owner => this.ownerInfo = owner);
    this.buildTOSUrl();
  }

  ngOnDestroy(): void {
    if (this.getOwnerSubs) {
      this.getOwnerSubs.unsubscribe();
    }
    if (this.manageOwnerSubs) {
      this.manageOwnerSubs.unsubscribe();
    }
    if (this.termsOfServiceSubs) {
      this.termsOfServiceSubs.unsubscribe();
    }
  }

  acceptTerms(): void {
    this.loading = true;
    // Create request object with only the fields expected by the PUT endpoint
    const requestData: OwnerUpdateRequest = {
      firstname: this.ownerInfo.firstname,
      lastname: this.ownerInfo.lastname,
      address: this.ownerInfo.address,
      mailingAddress: this.ownerInfo.mailingAddress || null,
      phoneNumbers: this.ownerInfo.phoneNumbers || [],
      acceptedTerms: true,
      acceptedTermsVersion: this.latestToS.version,
      acceptedTermsVersionId: this.latestToS.id,
      shelterCommunicationPreferences: this.ownerInfo.shelterCommunicationPreferences || []
    };

    this.manageOwnerSubs = this.ownerFamilyService.putOwnerInfo(requestData).subscribe({
      next: (owner: any) => {
        this.store.dispatch(setOwner({owner}));

        this.loading = false;
        this.activeModalService.close();
      },
      error: err => {
        this.loading = false;
        this.logger.log('Error while accepting terms of service', err);
      }
    });
  }

  private buildTOSUrl(): void {
    const environment = this.sharedLibraryService.getSharedLibraryConfig().environmentType;
    if (environment === 'local' || environment === 'development') {
      this.termsOfServiceURL = 'https://dev.petszel.com/terms-of-service';
    } else if (environment === 'beta') {
      this.termsOfServiceURL = 'https://beta.petszel.com/terms-of-service';
    } else {
      this.termsOfServiceURL = 'https://petszel.com/terms-of-service';
    }
  }
}
